import { IAccessor, ICreateAccessorPayload, IUpdateAccessorPayload } from 'interfaces';
import { accessorService } from 'services/api/AccessorService';

export const accessorApi = {
  listService: accessorService,
  getById: (id: number): Promise<IAccessor> => accessorService.get(id),
  create: (payload: ICreateAccessorPayload) => accessorService.create(payload),
  update: (id: number, payload: IUpdateAccessorPayload) =>
    accessorService.updateAccessor(id, payload)
};
